import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["breadcrumbs", "description", "children", "content", "primaryActions", "properties", "secondaryActions", "tabs", "title"];
import React from 'react';
import PageContent from './PageContent';
import PageHeader from './PageHeader';

var Page = function Page(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
      description = _ref.description,
      children = _ref.children,
      content = _ref.content,
      primaryActions = _ref.primaryActions,
      properties = _ref.properties,
      secondaryActions = _ref.secondaryActions,
      tabs = _ref.tabs,
      title = _ref.title,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", unhandledProps, children != null ? children : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHeader, {
    breadcrumbs: breadcrumbs,
    description: description,
    primaryActions: primaryActions,
    properties: properties,
    secondaryActions: secondaryActions,
    tabs: tabs,
    title: title
  }), /*#__PURE__*/React.createElement(PageContent, null, content)));
};

export default Page;